module.exports = __webpack_public_path__ + "static/media/ex1.4237f215.jpg";